import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import brief_error_icon from '../../assets/more_information.svg';

export const MoreInformationImage = () => (
  <Container
    flexShrink="0"
    width={242}
    height={138}
    style={{
      backgroundImage: `url(${brief_error_icon})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    }}
  />
);
